export default __webpack_public_path__ + "static/media/logo.7b580b98.png";